import { useState } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";

import { usePostContactUs } from "@/api/client/contactUs";
import { ContactSubmitSuccessModal } from "@/components/actions";
import PrimaryBtn from "@/components/actions/button/primaryBtn";
import AppInput from "@/components/data-input/input-field";
import AppTextAreaInput from "@/components/data-input/inputTextArea";
import { errorToast } from "@/components/feedback/toast";
import { contactSchema } from "@/schema/formSchema";

function ContactUsForm() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(contactSchema),
  });

  const { mutate: sendSuccessData, isLoading: isSubmittingContactForm } =
    usePostContactUs({
      onSuccess: () => {
        setIsModalOpen(true);
        reset();
      },
      onError: (error) => {
        errorToast(error.data.message);
      },
    });

  const onSubmitContactForm = (data) => {
    sendSuccessData(data);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitContactForm)}>
        <div className="w-full rounded-t-[0.75rem] py-[1.25rem]">
          <h3 className="text-[1.125rem] font-semibold ">Leave a message</h3>
        </div>
        <div className="space-y-[1.5rem] py-[1.5rem]">
          <AppInput
            labelName="Full Name"
            isFieldRequired
            placeholder="Enter your full name"
            name="name"
            register={register}
            error={errors.name}
          />
          <AppInput
            labelName="Email"
            isFieldRequired
            placeholder="Enter email address"
            name="email"
            register={register}
            error={errors.email}
          />
          <AppInput
            labelName="Title"
            isFieldRequired
            placeholder="Enter title"
            name="title"
            register={register}
            error={errors.title}
          />
          <AppTextAreaInput
            labelName="Message"
            isFieldRequired
            placeholder="Write here"
            name="comment"
            register={register}
            error={errors.comment}
          />
        </div>
        <div className="flex justify-end space-y-[1.5rem]">
          <PrimaryBtn
            btnText="Send Message"
            isLoading={isSubmittingContactForm}
            className="w-full py-[.875rem] md:w-[14.625rem] md:py-[1rem]"
          />
        </div>
      </form>

      <ContactSubmitSuccessModal
        isModalOpen={isModalOpen}
        hideModal={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default ContactUsForm;

ContactUsForm.propTypes = {
  headerText: PropTypes.string,
};
